import { Pipe, PipeTransform } from '@angular/core';
import { CalendarSource, CalendarSourceType } from '../data/calendar-source.interface';

interface PricingAndAvailability {
  available: boolean;
  sources: CalendarSource[];
}

@Pipe({
  name: 'isManualBlock',
  standalone: true,
})
export class IsManualBlockPipe implements PipeTransform {
  transform(date: string, pricingAndAvailability: Record<string, PricingAndAvailability> | null | undefined): boolean {
    return (
      pricingAndAvailability?.[date]?.available === false &&
      pricingAndAvailability?.[date]?.sources.some(
        (source) => source.type === CalendarSourceType.Availability && source.source === 'manual'
      )
    );
  }
}
